<template>
    <svg width="36" height="36" viewBox="0 0 36 36" xmlns="http://www.w3.org/2000/svg">
        <g fill="#033D89" fill-rule="evenodd">
            <path d="M16.128 13.603A.751.751 0 0 0 15 14.25v7.359a.751.751 0 0 0 1.117.654l6.425-3.61a.75.75 0 0 0 .01-1.3l-6.424-3.751z"/>
            <path d="M28.5 21.384a4.121 4.121 0 0 1-4.113 4.116H11.611A4.119 4.119 0 0 1 7.5 21.384v-6.77a4.117 4.117 0 0 1 4.111-4.114h12.776a4.119 4.119 0 0 1 4.113 4.115v6.77zM18 0C8.075 0 0 8.075 0 18c0 9.924 8.075 18 18 18s18-8.076 18-18c0-9.925-8.075-18-18-18z"/>
        </g>
    </svg>
</template>

<script>
export default {
    name: 'IconYoutubeDark',
};
</script>